import { Injectable } from '@angular/core';
import type { TVendor } from '@shared/jp/enums';
import { DiscountService as _DiscountService } from '@studiobuki/web-core/lib/discount';

@Injectable({
  providedIn: 'root',
})
export class DiscountService extends _DiscountService<TVendor> {}
